import { render, staticRenderFns } from "./FromFileOrUrl.vue?vue&type=template&id=97aacbba"
import script from "./FromFileOrUrl.vue?vue&type=script&setup=true&lang=ts"
export * from "./FromFileOrUrl.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports